import { Card, CardContent } from "@/components/ui/card";
import { usePurchaseOrderReportSummaryQuery } from "@/modules/reports/presentation/api/queries";
import { formatLakDisplay } from "@/shared/lib/format-number";
import { Link } from "@tanstack/react-router";
import { BarChart3Icon } from "lucide-react";

/** ສະຫຼຸບ PO ຄ້າງຮັບ ຢູ່ຫົວລາຍການ PO */
export function PurchaseOrderOpenSummaryStrip() {
  const { data, isLoading } = usePurchaseOrderReportSummaryQuery();

  if (isLoading) {
    return (
      <Card className="mb-4 border-dashed">
        <CardContent className="py-3 text-muted-foreground text-sm">
          ກຳລັງໂຫຼດສະຫຼຸບ PO...
        </CardContent>
      </Card>
    );
  }

  if (!data) return null;

  return (
    <Card className="mb-4 border-primary/20 bg-primary/5">
      <CardContent className="flex flex-wrap items-center justify-between gap-3 py-3 text-sm">
        <div className="flex flex-wrap gap-x-6 gap-y-1">
          <span>
            <strong className="tabular-nums">
              {data.openReceivablePoCount.toLocaleString("lo-LA")}
            </strong>{" "}
            PO ຄ້າງຮັບ
          </span>
          <span>
            ມູນຄ່າຄ້າງ{" "}
            <strong>{formatLakDisplay(data.valuePendingLak)}</strong>
          </span>
          <span>
            ລໍຖ້າອະນຸມັດ{" "}
            <strong className="tabular-nums">
              {data.submittedPendingCount.toLocaleString("lo-LA")}
            </strong>
          </span>
        </div>
        <Link
          to="/app/reports/inventory/purchase-orders"
          className="inline-flex items-center gap-1 font-medium text-primary hover:underline"
        >
          <BarChart3Icon className="size-4" />
          ລາຍງານເຕັມ
        </Link>
      </CardContent>
    </Card>
  );
}
